import { makeStyles } from '@material-ui/core/styles';
import { Typography, Container, Divider, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { MapModes } from '../../../constants/general';

const useStyles = makeStyles((theme)=> ({
    root: {
        position: 'absolute',
        margin: 'auto',
        top: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        backgroundColor: theme.palette.background.paper,
        borderBottomLeftRadius: theme.spacing(1),
        borderBottomRightRadius: theme.spacing(1),
    },
}))

function OrderSelectCounter(props){
    const classes = useStyles();
    const {t} = useTranslation('mapManagement')

    const {
        count, 
        mapMode, 
        mapSelectionCount, 
        onMapSelection, 
        onMapSelectionClear, 
        onMapModeChange, 
        onMapModeReset,
        onManualRoutingConfirm,
        onMapAssignFullClear,
        selectedWeight
    } = props

    function display(){
        if(mapSelectionCount > 0){
            return (
                <>
                    <Divider />
                    <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                        <Typography color="textPrimary" style={{flex: 1, textAlign: 'left'}}>{t('marker_section')}: {mapSelectionCount}</Typography>
                        <Button color="secondary" onClick={onMapSelection}>{t('common:ok')}</Button>
                        <Button color="secondary" onClick={onMapSelectionClear}>{t('common:clear')}</Button>
                    </div>
                    <Divider />
                    <div style={{textAlign: 'left', paddingTop: 10, paddingBottom: 10}}>
                        <Typography color="textPrimary" style={{flex: 1}}>{t('selected_weight')}: {selectedWeight}</Typography>
                    </div>
                </>
            )
        } else if(mapMode === MapModes.ASSIGN_ROUTE){
            return (
                <>
                    <Divider />
                    <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center'}}>
                        <Typography color="textPrimary" style={{flex: 1}}>{t('assign_route')}</Typography>
                        <div style={{display: 'flex',flexDirection: 'row'}}>
                            <Button color="secondary" onClick={onManualRoutingConfirm}>{t('common:ok')}</Button>
                            <Button color="secondary" onClick={onMapAssignFullClear}>{t('common:clear')}</Button>
                        </div>
                    </div>
                </>
            )
        } else {
            return null
        }
    }

    return (
        <Container
            className={classes.root}
            maxWidth='xs' 
        >
            <Typography color="textPrimary">{t('selected_order_count_text', {count})}</Typography>
            <Divider />
            <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                <Typography color="textPrimary">{t('common:current_mode')}: <span style={{color: 'green'}}>[{t(mapMode)}]</span></Typography>
                <div style={{display: 'flex',flexDirection: 'row'}}>
                    <Button color="secondary" onClick={toggleMapMode}>{t('common:toggle_mode')}</Button>
                    <Button color="secondary" onClick={onMapModeReset}>{t('common:reset')}</Button>
                </div>
            </div>
            {
                display()
            }
        </Container>
    )

    function toggleMapMode(){
        switch(mapMode){
            case MapModes.SELECT_MARKER:
                onMapModeChange(MapModes.ASSIGN_ROUTE)
                break;
            default: onMapModeChange(MapModes.SELECT_MARKER)
        }
    }
}

OrderSelectCounter.defaultProps = {
    count: 0,
    mapSelectionCount: 0,
    onMapSelection: ()=>{},
    onMapSelectionCancel: ()=>{}
}

export default OrderSelectCounter